module.exports = __webpack_public_path__ + "static/media/error-500-m.2eafc862.svg";